export const AVATAR_COLOR_MAP = [
  "neutral",
  "violet",
  "blue",
  "yellow",
  "pink",
  "teal",
];
